import { gql } from "@apollo/client";

export const TEMPLATE_FIELD_FIELDS = gql`
  fragment TemplateFieldFields on PermitField {
    key
    label
    fieldType
    displayOrder
    requiredForState
    editableAtStages
    ... on TextPermitField {
      maxLength
      isMultiLine
    }
    ... on BooleanPermitField {
      defaultValue
      trueLabel
      falseLabel
    }
    ... on NumberPermitField {
      minValue
      maxValue
      decimalPlaces
      unit
    }
    ... on DatePermitField {
      includeTime
    }
  }
`;

